import * as Colors from "../../../../globalStyles/administratorColors";

export const body = {
  paddingRight: "30px",
  paddingTop: "30px",
};

export const cardStyle = {
  backgroundColor: Colors.primary,
  color: "white",
  cursor: "pointer",
};

export const cardStyleSelected = {
  backgroundColor: Colors.accent,
  color: "white",
  cursor: "pointer",
};

export const categoryHeading = {
  textAlign: "center",
};

export const saveBtn = {
  textAlign: "right",
};
